var _rect, _path, _path2, _path3, _path4, _ellipse, _rect2, _ellipse2, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevisionBankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.999992,
    width: 69,
    height: 68,
    rx: 34,
    fill: "#264BE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4161 5.08999L42.3243 19.7155L47.4453 33.01L36.4465 32.9497L36.4161 5.08999Z",
    fill: "#258EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4163 5.07903L29.0756 19.6428L24.4477 32.8839L34.4467 32.9387L34.4163 5.07903Z",
    fill: "#258EEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4715 55.3897L27.7091 43.6005L24.4477 32.8839L31.447 32.9223L31.4715 55.3897Z",
    fill: "#258EEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4705 55.4391L44.2073 43.691L47.4453 33.01L40.4461 32.9716L40.4705 55.4391Z",
    fill: "#258EEA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.99964,
    ry: 3.5948,
    transform: "matrix(0.999985 0.00548309 0.00108968 0.999999 35.4201 8.67931)",
    fill: "#0B4664"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.99918,
    height: 22.4675,
    transform: "matrix(0.999985 0.00548309 0.00108968 0.999999 31.447 32.9223)",
    fill: "#258EEA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.99946,
    ry: 5.3922,
    transform: "matrix(0.999985 0.00548309 0.00108968 0.999999 35.4456 32.0455)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8208 57.7273L25.8281 58.0091L20.0456 46.854L51.0343 46.4172L45.8208 57.7273Z",
    fill: "#0B4664"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19.7957,
    height: 6.29361,
    transform: "matrix(-0.999616 0.0276969 -0.0421278 -0.999112 45.9739 63.7973)",
    fill: "#0B4664"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionBankLogo);
export default __webpack_public_path__ + "static/media/RevisionBankLogo.ecc9930c0b9300dfc7d423d26560046d.svg";
export { ForwardRef as ReactComponent };